import { render, staticRenderFns } from "./gallery-card31.vue?vue&type=template&id=1408846e&scoped=true"
import script from "./gallery-card31.vue?vue&type=script&lang=js"
export * from "./gallery-card31.vue?vue&type=script&lang=js"
import style0 from "./gallery-card31.vue?vue&type=style&index=0&id=1408846e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1408846e",
  null
  
)

export default component.exports